export default function Departments(){
    return (
        <div classname="section-title">
        <h1 className='section-title-text'>
            <span className='section-title-span'>Departments</span>
        </h1>
        </div>
    )

} 

